export const contactInfo = {
  email: "ryanhuse@gmail.com",
  location: "Houston, TX",
  social: {
    linkedin: {
      url: "https://www.linkedin.com/in/ryan-huse/",
      username: "ryan-huse",
    },
    // Add more social platforms as needed
    // twitter: {
    //   url: "https://twitter.com/yourusername",
    //   username: "@yourusername"
    // },
  },
  // Optional additional fields
  availability: {
    status: "Open to compelling engineering and technical leadership opportunities",
  },
  // kept minimal for professional contact
};
